import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  createTarget,
  deleteTarget,
  getAllTargets,
  getTargetByID,
  updateTarget,
} from "./services/target.services";
import { ITarget, ITargetInitialState } from "./targetModel";

const initialState: ITargetInitialState = {
  loading: false,
  error: "",
  TargetList: [],
  TargetPriceList: [],
  TargetID: null,
  TargetDetail: {
    from_date: "",
    to_date: "",
    sr_id: null,
    basic_per: null,
    target_per: null,
    distributor_id: null,
  },
  FilterTarget: {
    sr_name: "",
  },
};

const targetSlice = createSlice({
  name: "target",
  initialState,
  reducers: {
    clearTargetDetails: (state) => {
      state.TargetDetail = initialState.TargetDetail;
    },
    setTargetID: (state, action) => {
      state.TargetID = action.payload;
    },
    clearTargetID: (state) => {
      state.TargetID = initialState.TargetID;
    },
    clearTargetList: (state) => {
      state.TargetList = [];
    },
    setFilterTarget: (state, action) => {
      state.FilterTarget = action.payload;
    },

    clearFilterTarget: (state) => {
      state.FilterTarget = initialState.FilterTarget;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllTargets.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllTargets.fulfilled,
      (state, action: PayloadAction<ITarget[]>) => {
        state.loading = false;
        state.TargetList = action.payload || [];
      }
    );
    builder.addCase(getAllTargets.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TargetList = [];
    });

    builder.addCase(createTarget.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createTarget.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createTarget.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateTarget.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateTarget.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateTarget.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteTarget.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteTarget.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteTarget.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getTargetByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getTargetByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.TargetDetail = action.payload;
    });
    builder.addCase(getTargetByID.rejected, (state, action) => {
      state.loading = false;
      state.TargetDetail = initialState.TargetDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearTargetDetails,
  setTargetID,
  clearTargetID,
  clearTargetList,
  clearFilterTarget,
  setFilterTarget,
} = targetSlice.actions;
export default targetSlice.reducer;
